<template>
  <div id="app">
    <ZPOverlay
      v-if="!loading"
      ref="overlay"
      :params="params"
      :updateData="updateData"
      @load="updateData"
    />
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import ZPOverlay from './components/ZPOverlay.vue';

export default {
  name: 'App',
  components: {
    ZPOverlay,
  },

  data() {
    return {
      timer: '',
      loading: true,
      params: {
        styles: {
          user: {
            color: '#fff',
            borderRadius: 10,
            backgroundColor: 'rgba(0, 0, 0, 1)',
          },
          stats: {
            color: '#fff',
            borderRadius: 20,
            backgroundColor: '#000',
          },
          slider: {
            textColor: 'rgb(255, 255, 255)',
            labelColor: 'rgb(255, 118, 41)',
            backgroundColor: 'rgb(26, 33, 40)',
          },
          overlay: {
            textColor: 'rgb(255, 255, 255)',
            labelColor: 'rgb(255, 118, 41)',
            borderColor: 'rgb(255, 118, 41)',
            borderWidth: 3,
            borderRadius: 20,
            backgroundColor: 'rgba(255, 118, 41, 0)',
          },
          session: {
            color: '#fff',
            borderRadius: 10,
            backgroundColor: '#000',
          },
          placements: {
            firstColor: 'rgb(0, 210, 3)',
            otherColor: '#000000',
            borderRadius: 0,
            backgroundColor: '#151717',
          },
        },
        data: {
          position: 0,
          total_kills: 0,
          total_pts: 0,
          bestof: 0,
          rounds_count: 0,
          event_finished: false,
          user: {
            avatar: null,
            name: '',
          },
          placements: [],
          rounds: [],
        },
        options: {
          user: {
            visible: true,
          },
          stats: {
            key: 'alltime',
            visible: true,
          },
          slides: [
            'kpg',
            'gulag',
            'kd',
            'headshot',
            'wins',
          ],
          session: {
            timer: 437235,
            visible: false,
          },
          placements: {
            visible: true,
          },
        },
        stop: false,
      },
    };
  },

  created() {
    this.updateData();
    // this.timer = setInterval(this.updateData, 10000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    updateData() {
      this.params.data.rounds = [];
      const path = window.location.pathname.replace(/^\/|\/$/g, '');
      return axios.get(`https://api.zeyplay.com/commons/overlay/${path}`)
        .then((response) => {
          if (response.data.success) {
            this.loading = false;
            this.params.data.user.name = response.data.data.name;
            this.params.data.placements = response.data.data.places;
            this.params.data.position = response.data.data.position;
            this.params.data.total_kills = response.data.data.total_kills;
            this.params.data.total_pts = response.data.data.total_pts;
            this.params.data.rounds = response.data.data.rounds;
            this.params.data.bestof = response.data.data.bestof;
            this.params.data.rounds_count = response.data.data.rounds_count;
            this.params.data.event_finished = response.data.data.event_finished;

            // if (response.data.data.event_finished) {
            //   clearInterval(this.timer);
            // }
          } else {
            this.params.stop = true;
          }
        });
    },
  },
};
</script>
